/** 앱이 배포된 base path 접두사 (예: "/project/xxx"). 루트면 빈 문자열 */
export function getBasePathPrefix(): string {
  return __BASE_PATH__.split('/')
    .filter(Boolean)
    .map((seg) => `/${seg}`)
    .join('');
}

/** 로그인 흐름에서 목적지로 삼으면 안 되는 인증 관련 경로 */
const AUTH_WORKFLOW_PATHS = [
  '/auth',
  '/login',
  '/signup',
  '/pending',
  '/forgot-password',
  '/reset-password',
];

function isAuthWorkflowPath(pathname: string): boolean {
  return AUTH_WORKFLOW_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

/**
 * 로그인 후 돌아갈 목적지(next)를 검증합니다.
 * 같은 출처의 내부 경로(정확히 하나의 "/"로 시작)만 허용하고,
 * 절대/프로토콜 상대 URL과 인증 관련 경로는 모두 "/" 로 대체합니다.
 */
export function validateOrdinaryPostAuthNext(raw: string | null | undefined): string {
  if (!raw) return '/';
  const value = raw.trim();
  if (!value) return '/';
  if (!value.startsWith('/') || value.startsWith('//')) return '/';
  if (value.includes('\\') || value.includes('://')) return '/';

  let parsed: URL;
  try {
    parsed = new URL(value, window.location.origin);
  } catch {
    return '/';
  }
  if (parsed.origin !== window.location.origin) return '/';
  if (isAuthWorkflowPath(parsed.pathname)) return '/';

  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}

/** 이메일 인증/매직링크가 돌아올 콜백 주소 (base path 포함) */
export function getAuthCallbackUrl(next?: string | null): string {
  const base = `${window.location.origin}${getBasePathPrefix()}/auth/callback`;
  const safeNext = validateOrdinaryPostAuthNext(next);
  if (safeNext !== '/') {
    return `${base}?next=${encodeURIComponent(safeNext)}`;
  }
  return base;
}

/** 비밀번호 재설정 메일이 돌아올 주소 (복구 전용, 검증기 우회) */
export function getRecoveryRedirectUrl(): string {
  return `${window.location.origin}${getBasePathPrefix()}/auth/callback?next=/auth/reset-password`;
}